// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { SwitchContainer, SwitchButton } from '../styles/UnitSwitch.style';
import { KEY_CODES } from '../../../../../../../constants/keyboard.constants';

const UnitSwitch = ({ selectedUnit, onUnitChange, activeDepartment, hideUnitMetic }) => {
  if (!isEmpty(hideUnitMetic) && hideUnitMetic.includes(activeDepartment)) {
    return null;
  }

  const handleToggle = () => {
    const newUnit = selectedUnit === 'US' ? 'METRIC' : 'US';
    onUnitChange(newUnit);
  };

  const handleOnKeyPress = (e) => {
    const { KEY_ENTER, KEY_SPACE } = KEY_CODES;
    if (e.keyCode === KEY_ENTER || e.keyCode === KEY_SPACE) {
      e.preventDefault();
      handleToggle();
    }
  };

  return (
    <SwitchContainer className="dynamic-unit-switch-section">
      <SwitchButton
        tabIndex={0}
        active={selectedUnit === 'US'}
        aria-pressed={selectedUnit === 'US'}
        aria-label="Use US size units"
        onClick={handleToggle}
        onKeyDown={handleOnKeyPress}
      >
        <span>US</span>
      </SwitchButton>
      <SwitchButton
        tabIndex={0}
        active={selectedUnit === 'METRIC'}
        aria-pressed={selectedUnit === 'METRIC'}
        aria-label="Use Metric size units"
        onClick={handleToggle}
        onKeyDown={handleOnKeyPress}
      >
        <span>METRIC</span>
      </SwitchButton>
    </SwitchContainer>
  );
};

UnitSwitch.propTypes = {
  selectedUnit: PropTypes.string.isRequired,
  onUnitChange: PropTypes.func.isRequired,
  activeDepartment: PropTypes.string.isRequired,
  hideUnitMetic: PropTypes.shape([]).isRequired,
};

export default UnitSwitch;
export { UnitSwitch as UnitSwitchVanilla };
